import { jsx } from "react/jsx-runtime";
import BaseSlider from "@mui/material/Slider/index.js";
import { rootStyles } from "./slider.styles.js";
import "@mui/material";
import "../../themes/typography/typography.js";
import "../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../themes/typography/utils/typographyVariants/typographyVariants.js";
const Slider = (props) => {
  return /* @__PURE__ */ jsx(BaseSlider, { sx: rootStyles, ...props });
};
export {
  Slider
};
